var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',_vm._l((_vm.table_rows),function(row){return _c('li',[_c('router-link',{attrs:{"to":'/' + (row.manager_type == 'Agency' ? 'agencies' : 'agents') + '/view/'+row.manager_id}},[_vm._v(_vm._s(row.manager_name))]),_vm._v(" manages "+_vm._s(row.seller_name)+" "),(row.commission)?_c('span',[_vm._v("at "+_vm._s(row.commission))]):_vm._e()],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }